import React, { useCallback, useState } from 'react';
import GroupSettingCard from './groupSettingCard';
import TeamsSettingCard from './teamSettingCard';
import PrioritySettingCard from './prioritieSettindCard';
import LabelsSettingCard from './labelsSettingCard';
import Modal from '../modals/modal';
import InviteTeamsModal from '../modals/inviteTeamsModal';
import DeleteModal from '../modals/deleteModal';
import Labelmodal from '../modals/labelModal';
import UserPreferenceSingleton from '../../helpers/userPreferenceSingleton';
import { deleteTaskGroup, updateGroupDetail } from '../../services/taskServices';
import { captureException } from '../../services/logService';
import { removeInvitedMember } from '../../services/projectServices';
import StatusSettingCard from './statusSettingCard';
import AddStatusModal from '../modals/addStatusmodal';
import GithubSettingCard from './githubRepository';
import SettingCard from './settingCard';
import { rootStore } from '../../mobx/rootStore';
import { ProjectModel } from '../../mobx/models/project';
import { WorkspaceModel } from '../../mobx/models/workspace';
import { UserModel } from '../../mobx/models/user';
import { Label, RawTaskGroup } from '../../mobx/interfaces/project';
import { observer } from 'mobx-react-lite';
import InviteMemberModal from '../modals/inviteMemberModal';
import CreateGroupModal from '../modals/createGroupModal';
import { TaskGroupInterface } from '../../interfaces/TaskInterface';
import { StatusListInterface } from '../../interfaces/ProjectInterface';
import SuccessfulModel from '../modals/successfullModal';
import VercelSettingCard from './vercelSettingCard';
import TasksFilterCard from './tasksFilterSettingCard';
import ProjectInfo from './projectInfoCard';

interface Props {
  currentProject: ProjectModel;
  themeMode: { theme: string };
  onUpdateMileStone: (value: boolean) => void;
  onUpdateEstimate: (value: boolean) => void;
  onUpdateMultiAssignee?: (value: boolean) => void;
  onUpdateStatus: (value: boolean) => void;
  onUpdatePriority: (value: boolean) => void;
  onUpdateLabels: (value: boolean) => void;
  onUpdateGroup: (value: boolean) => void;
  taskGroups: TaskGroupInterface[];
  loading: boolean;
  customersUsers: UserModel[];
  paramsId?: string;
  deleteLabel?: (id: string) => void;
  loadData: () => void;
  setLoading: (value: boolean) => void;
  workspaceDetails: WorkspaceModel;
  loadingButton: {
    group: boolean;
    status: boolean;
    priority: boolean;
    label: boolean;
    multiAssignee: boolean;
    estimation: boolean;
    milestone: boolean;
  };
}

const SettingCards: React.FC<Props> = (props) => {
  const {
    currentProject,
    themeMode,
    onUpdateMileStone,
    onUpdateEstimate,
    onUpdateMultiAssignee,
    onUpdatePriority,
    onUpdateLabels,
    taskGroups,
    loading,
    customersUsers,
    paramsId,
    deleteLabel,
    loadData,
    setLoading,
    workspaceDetails,
    onUpdateStatus,
    onUpdateGroup,
    loadingButton
  } = props;
  //States
  const [ModalOpen, setModalOpen] = useState(false);
  const [isMainModel, setMainModel] = useState(false);
  const [isSubModel, setSubModel] = useState(false);
  const [isDeleteMemberModel, setIsDeleteMemberModel] = useState(false);
  const [isMemberId, setIsMemberId] = useState('');
  const [isDeleteLabelModel, setIsDeleteLabelModel] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [labelId, setLabelId] = useState('');
  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
  const [statusType, setStatusType] = useState(0);
  //Set edit data for model
  const [groupData, setGroupData] = useState<TaskGroupInterface | null>(null);
  const [statusData, setStatusData] = useState<StatusListInterface | null>(null);
  const [labelData, setLabelData] = useState<Label | null>(null);
  const [isSuccessfulModalOpen, setIsSuccessfulModalOpen] = useState(false);
  const [clientLoginUrl, setClientLoginUrl] = useState('');
  //Mobx store variables
  const { workspaceStore, settingStore } = rootStore;
  const { currentWorkspace: workspace } = workspaceStore;
  const { settingIntegration } = settingStore;

  const handleOnclickOpenModel = () => {
    setIsSuccessfulModalOpen(true);
  };

  const handleOnclickCloseModel = () => {
    setIsSuccessfulModalOpen(false);
  };

  const onClickDeleteLabel = useCallback(
    (labelId: string) => {
      if (deleteLabel) deleteLabel(labelId);
      setIsDeleteLabelModel(false);
    },
    [deleteLabel]
  );

  const onCloseGroupModal = useCallback(() => {
    setGroupData(null);
    setModalOpen(false);
  }, []);

  const onClickEditGroup = useCallback((group: TaskGroupInterface) => {
    setGroupData(group);
    setModalOpen(true);
  }, []);

  const onClickEditLabel = useCallback((item: Label) => {
    setLabelData(item);
    setIsOpen(true);
  }, []);

  const onCreateNewLabel = () => {
    setIsOpen(true);
  };

  const onCloseNewLabel = () => {
    setLabelData(null);
    setIsOpen(false);
  };

  const OpenDeleteMemberModel = (id: string) => {
    setIsDeleteMemberModel(true);
    setIsMemberId(id);
  };

  const onCloseDeleteMemberModel = () => {
    setIsDeleteMemberModel(false);
  };

  const onSubModel = () => {
    setMainModel(false);
    setSubModel(true);
  };

  const onCloseSubModal = (clientUrl?: string) => {
    setSubModel(false);
    if (clientUrl) {
      setClientLoginUrl(clientUrl);
      handleOnclickOpenModel();
    }
  };

  const openDeleteLabelModel = (id: string) => {
    setIsDeleteLabelModel(true);
    setLabelId(id);
  };

  const closeDeleteLabelModel = () => {
    setIsDeleteLabelModel(false);
  };

  const handleDragEnd = async (sourceIndex: number, destinationIndex: number) => {
    const updatedGroupNames = Array.from(taskGroups);
    const [removed] = updatedGroupNames.splice(sourceIndex, 1);
    updatedGroupNames.splice(destinationIndex, 0, removed);
    const updatedTaskGroups: RawTaskGroup[] = updatedGroupNames?.map((item, index) => {
      return { ...(item || {}), index: index };
    });
    rootStore.projectStore.currentProject?.setTaskGroups(updatedTaskGroups);
    const updatePromises = updatedTaskGroups?.map((item) => {
      const { id, index } = item;
      const payload = { itemId: id, index: index };
      return updateGroupDetail(payload, true);
    });
    try {
      await Promise.all(updatePromises);
    } catch (error) {
      captureException(error);
    }
  };

  const closeInviteModal = () => {
    setMainModel(false);
  };

  const onClickDeleteMember = useCallback(
    async (memberId: string) => {
      try {
        setLoading(true);
        const userDetails = UserPreferenceSingleton.getInstance().getCurrentUser();
        const result = await removeInvitedMember(userDetails?.id, currentProject?.id, memberId);
        if (result) {
          loadData();
        }
      } catch (error) {
        captureException(error);
      } finally {
        setLoading(false);
      }
      setIsDeleteMemberModel(false);
    },
    [currentProject?.id, loadData, setLoading]
  );

  const deleteGroup = useCallback(
    async (item: { id: string }) => {
      try {
        setLoading(true);
        const result = await deleteTaskGroup(item?.id);
        if (result) {
          loadData();
        }
      } catch (error) {
        captureException(error);
      } finally {
        setLoading(false);
      }
    },
    [loadData, setLoading]
  );

  const onCloseStatusModal = useCallback(() => {
    setIsStatusModalOpen(false);
    setStatusData(null);
  }, []);

  return (
    <>
      <ProjectInfo currentProject={currentProject!} />
      <TeamsSettingCard
        setMainModel={(value) => setMainModel(value)}
        OpenDeleteMemberModel={(id) => OpenDeleteMemberModel(id)}
      />
      {/* task filter card ui */}
      <TasksFilterCard />
      <GroupSettingCard
        themeMode={themeMode}
        handleDragEnd={handleDragEnd}
        taskGroups={taskGroups}
        onClickEditGroup={(group) => onClickEditGroup(group)}
        deleteGroup={(group) => deleteGroup(group)}
        loading={loading}
        setModalOpen={(value) => setModalOpen(value)}
        onUpdateGroup={(value) => onUpdateGroup(value)}
        loadingButton={loadingButton?.group}
      />
      <StatusSettingCard
        themeMode={themeMode}
        loadingButton={loadingButton?.status}
        setModalOpen={(value) => setIsStatusModalOpen(value)}
        onUpdateStatus={(value) => onUpdateStatus(value)}
        setStatusType={(value) => setStatusType(value)}
        setStatusData={setStatusData}
      />
      <PrioritySettingCard
        themeMode={themeMode}
        onUpdatePriority={(value) => onUpdatePriority(value)}
        loadingButton={loadingButton?.priority}
      />
      <LabelsSettingCard
        onUpdateLabels={(value) => onUpdateLabels(value)}
        openDeleteLabelModel={(id) => openDeleteLabelModel(id)}
        onClickEditLabel={(item) => onClickEditLabel(item)}
        handleclick={onCreateNewLabel}
        loadingButton={loadingButton?.label}
      />
      {/* multi assign or single assign */}
      <SettingCard
        onUpdateSetting={(value) => {
          if (onUpdateMultiAssignee) onUpdateMultiAssignee(value);
        }}
        loadingButton={loadingButton?.multiAssignee}
        title='Multiple assignee'
        subtitle='To enable this feature, you can allow tasks to be assigned to multiple members.'
      />
      {/* Estimation on and off */}
      <SettingCard
        onUpdateSetting={(value) => {
          if (onUpdateEstimate) onUpdateEstimate(value);
        }}
        loadingButton={loadingButton?.estimation}
        title='Estimation'
        subtitle='Estimates communicate task complexity and cycle capacity. Choose how to estimate with your team below.'
      />
      {/* Milestone on and off */}
      <SettingCard
        onUpdateSetting={(value) => {
          if (onUpdateMileStone) onUpdateMileStone(value);
        }}
        loadingButton={loadingButton?.milestone}
        title='Milestone'
        subtitle='Milestones communicate progress, validate accomplishments, and help track adherence to schedules and objectives.'
      />
      {/* Github repository card */}
      {settingIntegration?.github_connected && <GithubSettingCard />}

      {/* Vercel integration card */}
      {settingIntegration?.vercel_connected && <VercelSettingCard />}

      <Modal open={isMainModel} onClose={closeInviteModal} maxWidth={'400px'}>
        <InviteMemberModal
          workspace={workspaceDetails}
          currentProject={currentProject}
          customersUsers={customersUsers}
          onSubModel={onSubModel}
          setLoading={setLoading}
          onClose={closeInviteModal}
        />
      </Modal>
      <Modal open={ModalOpen} onClose={onCloseGroupModal} maxWidth={'462px'}>
        <CreateGroupModal groupData={groupData} loadData={loadData} onClose={onCloseGroupModal} />
      </Modal>
      <Modal open={isStatusModalOpen} onClose={onCloseStatusModal} maxWidth={'334px'}>
        <AddStatusModal
          onCancel={onCloseStatusModal}
          statusType={statusType}
          projectId={currentProject?.id}
          statusData={statusData}
        />
      </Modal>
      <Modal open={isSubModel} onClose={onCloseSubModal} maxWidth={'400px'}>
        <InviteTeamsModal
          onCancel={onCloseSubModal}
          project_id={paramsId}
          isTextVisible={true}
          projectName={currentProject?.name}
          workspace_id={workspace?.id!}
        />
      </Modal>
      <Modal open={isSuccessfulModalOpen} onClose={handleOnclickCloseModel} maxWidth={'420px'}>
        <SuccessfulModel clientLoginUrl={clientLoginUrl} onCancel={handleOnclickCloseModel} />
      </Modal>
      <Modal open={isDeleteMemberModel} onClose={onCloseDeleteMemberModel} maxWidth={'334px'}>
        <DeleteModal
          onClose={onCloseDeleteMemberModel}
          loading={loading}
          buttonText='Remove'
          onOk={() => onClickDeleteMember(isMemberId)}
          modalTitle='Remove Member?'
          description='Are you sure you want to remove this member from the project?'
        />
      </Modal>
      <Modal open={isDeleteLabelModel} onClose={closeDeleteLabelModel} maxWidth={'334px'}>
        <DeleteModal
          onClose={closeDeleteLabelModel}
          loading={loading}
          onOk={() => onClickDeleteLabel(labelId)}
          modalTitle='Delete Label?'
          description='Are you sure you want to delete this label?'
        />
      </Modal>
      <Modal open={isOpen} onClose={onCloseNewLabel} maxWidth={'462px'}>
        <Labelmodal onClose={onCloseNewLabel} labelData={labelData} />
      </Modal>
    </>
  );
};

export default observer(SettingCards);
